import React from 'react';
import {Breadcrumb} from 'antd';
export const LCBreadcrumb=(props)=>(
<Breadcrumb {...props}>{props.children}</Breadcrumb>)
